<div class="nc-emoji-switch" [ngClass]="'nc-emoji-switch-' + ncSize">
    <div class="switch-disabled" *ngIf="ncDisabled"></div>
    <span class="switch__wrapper">
        <input class="switch__input" type="checkbox" [ngModel]="value" (ngModelChange)="onInputChange($event)" />
        <span class="switch__emoji">
            <span class="switch__emoji-face switch__emoji-face--sad">
                <span class="switch__emoji-eye"></span>
                <span class="switch__emoji-eye"></span>
                <span class="switch__emoji-mouth"></span>
            </span>
            <span class="switch__emoji-face">
                <span class="switch__emoji-eye"></span>
                <span class="switch__emoji-eye"></span>
                <span class="switch__emoji-mouth"></span>
            </span>
        </span>
    </span>
</div>